import styled from '@mui/material/styles/styled';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';
import indigo from '@mui/material/colors/indigo';
import blue from '@mui/material/colors/blue';
import grey from '@mui/material/colors/grey';
import common from '@mui/material/colors/common';

import googleSVG from '../../assets/images/google_buttn.svg';
import facebookSVG from '../../assets/images/facebook_buttn.svg';
import twitterSVG from '../../assets/images/twitter_buttn.svg';

export const GoogleButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(common.white),
  backgroundColor: grey[200],
  '&:hover': {
    backgroundColor: grey[50],
  },
}));

export const FacebookButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(indigo[500]),
  backgroundColor: indigo[500],
  '&:hover': {
    backgroundColor: indigo[700],
    backgroundImage: '../assets/images/',
  },
}));

export const TwitterButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(blue[500]),
  backgroundColor: blue[500],
  '&:hover': {
    backgroundColor: blue[700],
  },
}));

export const SocialMediaButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.getContrastText(common.white),
  backgroundColor: 'transparent',
  border: '1px solid #bbb',
  '&:hover': {
    backgroundColor: grey[50],
  },
}));

const imgStyle = {
  height: 18,
  width: 18,
  verticalAlign: 'top',
  border: 'none',
  display: 'inline-block',
};

export const googleSvgIcon = (
  <Icon>
    <img style={imgStyle} alt="Google" src={googleSVG} />
  </Icon>
);

export const fbSvgIcon = (
  <Icon>
    <img style={imgStyle} className="indigo" alt="FB" src={facebookSVG} />
  </Icon>
);

export const twSvgIcon = (
  <Icon>
    <img style={imgStyle} alt="Twitter" src={twitterSVG} />
  </Icon>
);
